import { Typography } from "@material-ui/core";
import React, { FC } from "react";
import { useParams } from "react-router";
import { getLanguageFromKey } from "../../utils/LanguageHelper";
import { useGetLifeExamSessionsAvailableForSignUpQuery } from "../../api/rtk/SignUpApi";
import LoadingIndicator from "../common/LoadingIndicator";
import Alert from "@material-ui/lab/Alert";
import LifeExamSessions from "./LifeExamSessions";
import TranslatedMessage from "../translations/TranslatedMessage";
import LifeExamDays from "./LifeExamDays";

const LifeExamsPage: FC = () => {
  const { languageKey, examSessionId } = useParams<{ languageKey: string; examSessionId?: string }>();
  const sessionLanguage = getLanguageFromKey(languageKey);
  const { data: availableExamSessions, isFetching: isAvailableExamSessionsLoading } =
    useGetLifeExamSessionsAvailableForSignUpQuery({ language: sessionLanguage });

  const isLoading = isAvailableExamSessionsLoading;

  if (isLoading || !availableExamSessions) {
    return <LoadingIndicator show={true} />;
  }

  if ((availableExamSessions?.length ?? 0) === 0) {
    return (
      <Alert severity="warning">
        <TranslatedMessage id="lifeExams.messages.noAvailableExams" />
      </Alert>
    );
  }

  return (
    <>
      <Typography variant="h5">
        <TranslatedMessage id="lifeExams.title" />
      </Typography>

      {!examSessionId && <LifeExamSessions sessions={availableExamSessions} language={sessionLanguage} />}
      {examSessionId && <LifeExamDays
        session={availableExamSessions.find(e => e.id === examSessionId)}
        sessionLanguage={sessionLanguage}
      />}
    </>
  );
};

export default LifeExamsPage;
